export const API_BASE_URL = process.env.BUN_PUBLIC_BACKEND_URL || "http://localhost:4800";
